module.exports = __webpack_public_path__ + "img/icon-1.5f5ea0f4.png";